import React from "react";

interface Props {
  settings: any;
  setSettings: any;
}
const VehicleOwnerContingents = (props: Props) => {
  const {} = props;
  return (
    <>
      <span>vehicleOwnerContingents</span>
    </>
  );
};

export default VehicleOwnerContingents;
